import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import dayjs from 'dayjs';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { globalClasses } from '../../utils/globalUtils';
import CheckIcon from '../../../../assets/allInvoice-assets/check.svg';
import CloseIcon from '../../../../assets/allInvoice-assets/x.svg';
import Toast from '../../utils/Toast';
import { classes } from './utils';

const UpdateColumnData = (
  currentValue,
  mergedData,
  field,
  selectedVersion,
  id,
  updateOpenedData,
  setIsEdited,
) => {
  mergedData.forEach((d) => {
    if (d.label === field && d.id === id) {
      const modifiedData = d;
      modifiedData.value = currentValue;
      modifiedData.validated = true;
      modifiedData.version = selectedVersion;
      modifiedData.label = field;
      modifiedData.short_desc = field;
      updateOpenedData(d);
      setIsEdited(true);
    }
  });
};
const DateTimePickersEditor = (params) => {
  const { colDef, mergedData, updateOpenedData, selectedVersion, setIsEdited } =
    params;
  const value = params?.data[colDef.headerName].value;
  const dateValue = value ? dayjs(value) : null;
  const [currentValue, setCurrentValue] = useState(dateValue);
  const [editedData, setEditedData] = useState('');
  const [id, setId] = useState('');
  const handleCancle = () => {
    params?.api.stopEditing();
  };
  const handleSave = async () => {
    try {
      await UpdateColumnData(
        editedData,
        mergedData,
        colDef.headerName,
        selectedVersion,
        id,
        updateOpenedData,
        setIsEdited,
      );
      params?.api.purgeInfiniteCache();
      params?.api.stopEditing();
      setIsEdited(false);
      Toast({
        message: `${colDef.headerName} Successfully Updated`,
        variant: 'success',
      });
    } catch (error) {
      Toast({
        message: error,
        variant: 'error',
      });
    }
  };
  useEffect(() => {
    if (mergedData && mergedData.length > 0) {
      mergedData.forEach((d) => {
        if (
          d?.product === params?.data[colDef.headerName]?.product &&
          d?.label === colDef.headerName &&
          d?.id === params?.data[colDef.headerName]?.id
        ) {
          setId(d?.id);
        }
      });
    }
  }, []);
  const handleClearDate = () => {
    setCurrentValue(null);
    setEditedData('');
  };
  const handleDatePickerChange = (newPaymentDate) => {
    if (!newPaymentDate) {
      setEditedData('');
      setCurrentValue(null);
    } else {
      const datePart = dayjs(newPaymentDate.$d); // Convert to dayjs object if necessary
      let formattedDateForPayment;
      let formattedDate;

      // Split datePart into date and time parts
      const formattedDatePart = datePart.format('YYYY-MM-DD HH:mm:ss');
      const [newDatePartString, newTimePart] = formattedDatePart.split(' ');
      const [datePartString] = value.split(' ');

      // Check for different formats and delimiters based on datePartString
      if (datePartString.includes('/')) {
        const parts = newDatePartString.split('-');
        // Assuming MM/DD/YYYY format
        formattedDateForPayment = `${parts[1]}/${parts[2]}/${parts[0]}`;

        const combinedDateTime = `${formattedDateForPayment} ${newTimePart || '00:00:00'}`;

        // Conditionally format date with or without time part
        if (newTimePart === '00:00:00' || !newTimePart) {
          formattedDate = dayjs(formattedDateForPayment, 'MM/DD/YYYY').format(
            'MM/DD/YYYY',
          );
        } else {
          formattedDate = dayjs(combinedDateTime, 'MM/DD/YYYY HH:mm').format(
            'MM/DD/YYYY HH:mm',
          );
        }
      } else if (datePartString.includes('-')) {
        const parts = newDatePartString.split('-');
        // Assuming YYYY-MM-DD format
        formattedDateForPayment = `${parts[0]}-${parts[1]}-${parts[2]}`;

        const combinedDateTime = `${formattedDateForPayment} ${newTimePart || '00:00:00'}`;

        // Conditionally format date with or without time part
        if (newTimePart === '00:00:00' || !newTimePart) {
          formattedDate = dayjs(formattedDateForPayment, 'YYYY-MM-DD').format(
            'DD-MMM-YYYY',
          );
        } else {
          formattedDate = dayjs(combinedDateTime, 'YYYY-MM-DD HH:mm').format(
            'DD-MMM-YYYY HH:mm',
          );
        }
      } else {
        // Handle other cases, assuming DD-MMM-YYYY format like 20-May-18
        const parts = newDatePartString.split('-');
        formattedDateForPayment = `${parts[2]}-${datePart.format('MMM')}-${parts[0]}`;

        // No time part for this format
        formattedDate = dayjs(formattedDateForPayment, 'DD-MMM-YYYY').format(
          'DD-MMM-YYYY',
        );
      }

      setEditedData(formattedDate);
      setCurrentValue(datePart); // Set date object as needed
    }
  };

  return (
    <Box className={classes.documentEditCellBox}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DateTimePicker
          clearable
          required
          reduceAnimations
          format="MM/DD/YYYY HH:mm"
          slotProps={{
            field: {
              clearable: true,
              onClear: handleClearDate,
              size: 'small',
              sx: { width: '100%' },
              error: false,
            },
            textField: {
              inputProps: {
                readOnly: true,
              },
            },
          }}
          value={currentValue || null}
          onChange={handleDatePickerChange}
          views={['year', 'month', 'day', 'hours', 'minutes']}
        />
      </LocalizationProvider>
      <Box className={classes.editCellActionIcons}>
        <Box
          component="img"
          src={CheckIcon}
          alt="CheckIcon"
          className={`${classes.editIcon} ${globalClasses.visibility}`}
          onClick={() => {
            handleSave(mergedData);
          }}
        />
        <Box
          component="img"
          src={CloseIcon}
          alt="CloseIcon"
          className={classes.editIcon}
          onClick={handleCancle}
        />
      </Box>
    </Box>
  );
};

export default DateTimePickersEditor;
